<template>
  <el-dialog
    :visible.sync="visible"
    width="400px"
    class="dialog"
    :close-on-click-modal="false"
    @close="dialogClose"
    append-to-body
  >
    <span slot="title"> </span>
    <Login
      v-if="dialogType == 'login'"
      @toRegister="registerClick"
      @forgetPwd="dialogType = 'forgetPwd'"
      @loginSuccess="loginSuccess"
    />
    <ForgetPwd
      v-if="dialogType == 'forgetPwd'"
      @setPwdSuccess="dialogType = 'login'"
    />
  </el-dialog>
</template>
<script>
import Login from "@/components/Login/index";
import ForgetPwd from "@/components/HeadBar/ForgetPwd";
import { SET_SHOWLOGIN } from "@/store/types";
export default {
  components: {
    Login,
    ForgetPwd,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      dialogType: "login",
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    registerClick() {
      this.visible = false;
      this.toRegister();
    },
    toRegister() {
      this.$jump.push({ name: "register" });
    },
    dialogClose() {
      if (this.dialogType) {
        // this.dialogType = "";
        this.$store.commit(SET_SHOWLOGIN, false);
      }
    },
    loginSuccess(token) {
      this.visible = false;
      this.$store.dispatch("LoginSuccess", token);
      this.$emit("loginSuccess");
    },
  },
};
</script>
